/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Group } from './Group';
import {
    GroupFromJSON,
    GroupFromJSONTyped,
    GroupToJSON,
} from './Group';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface GroupsResponse
 */
export interface GroupsResponse extends Status {
    /**
     * 
     * @type {Array<Group>}
     * @memberof GroupsResponse
     */
    groups: Array<Group>;
}

/**
 * Check if a given object implements the GroupsResponse interface.
 */
export function instanceOfGroupsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "groups" in value;

    return isInstance;
}

export function GroupsResponseFromJSON(json: any): GroupsResponse {
    return GroupsResponseFromJSONTyped(json, false);
}

export function GroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'groups': ((json['groups'] as Array<any>).map(GroupFromJSON)),
    };
}

export function GroupsResponseToJSON(value?: GroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'groups': ((value.groups as Array<any>).map(GroupToJSON)),
    };
}

